import { dataMember, required, typedArray } from 'santee-dcts';

export class UserSearch {

    @dataMember()
    @required()
    public userPk: number;

    @dataMember()
    @required({ nullable: true })
    public firstName: string;

    
    @dataMember()
    @required({ nullable: true })
    public lastName: string;

    @dataMember()
    @required({ nullable: true })
    public email: string;

    public toString() {
        return `${this.firstName} ${this.lastName} (${this.email})`;
    }
}

export class UserSearchReadModel {
    @dataMember()
    @required()
    @typedArray(UserSearch)
    public users: UserSearch[];
}